import API from '../../utils/api';
import * as types from './types';
import { defaultLocale } from '../../utils/translation';
import LocalStorage from '../../utils/localStorage';
import { ENDPOINT_URL } from '../../constants/defaultValues';

export const getResults = (
    { search, sportTypeId, categoryId, leagueId, startDate, endDate, orderId },
    pageIndex
) => async dispatch => {
    dispatch({
        type: types.GET_EVENT_RESULTS_REQUEST,
    });
    const lang = LocalStorage.getItem('lang') || defaultLocale;

    const params = {
        sportTypeId,
        orderId,
        pageIndex,
        pageSize: 50,
        startDate,
        endDate,
    };

    if (search) params.search = search;
    if (categoryId) params.categoryId = categoryId;
    if (leagueId) params.leagueId = leagueId;

    await API.get(`${ENDPOINT_URL}/events/results`, {
        headers: { 'x-lang': lang },
        params,
    })
        .then(res => {
            const { info, item } = res.data;
            if (info.success) {
                dispatch({
                    type: types.GET_EVENT_RESULTS_SUCCESS,
                    payload: item,
                    hasMore: item.results.length >= 10,
                });
            }
        })
        .catch(err => console.log({ err }));
};

export const clearMatchResults = () => ({
    type: types.CLEAR_MATCH_RESULTS,
});
